import { P2GBox, P2GContainer, P2GGrid } from '@parcel2go/core-ui';

type props = {
  children: React.ReactNode;
  skip?: React.ReactNode;
  next?: React.ReactNode;
};

export const OnboardingActionBar = ({ children, skip, next }: props) => (
  <P2GBox
    sx={{
      position: 'sticky',
      zIndex: 2,
      bottom: 0,
      left: 0,
      right: 0,
      background: '#FFFFFF',
      boxShadow: '0px -5px 4px rgba(255, 255, 255, 0.5)',
      borderTop: '1px solid #E6E6E6',
      pt: 2,
      pb: 2,
      width: 'calc(100vw - 15px)',
      mt: { xs: 4, sm: 16 },
      minHeight: '90px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    {!next && !skip ? (
      <>{children}</>
    ) : (
      <P2GContainer maxWidth="lg">
        <P2GGrid
          container
          spacing={2}
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { sm: 'center' },
            flexWrap: { xs: 'wrap', sm: 'nowrap' }
          }}
        >
          {children && (
            <P2GGrid item flexGrow={1} order={0}>
              <P2GBox sx={{ textAlign: { xs: 'center', sm: 'left' } }}>{children}</P2GBox>
            </P2GGrid>
          )}
          {skip && (
            <P2GGrid item order={{ xs: 2, sm: 1 }}>
              {skip}
            </P2GGrid>
          )}
          {next && (
            <P2GGrid item order={{ xs: 1, sm: 2 }}>
              {next}
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GContainer>
    )}
  </P2GBox>
);
